import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { getStorage, setStorage } from '@/utils/payment';

/**
 * 保存订单参数到sessionStorage, 进入首页时候触发
 * 该hooks为的就是为了避免一些关键参数丢失问题
 */
const useSaveOrderParams = () => {
  const router = useRouter();

  useEffect(() => {
    if (/cashier-desk\/home/.test(router.asPath as unknown as string)) {
      const _orderParams = getStorage('sessionStorage', 'orderParams');
      setStorage('sessionStorage', 'orderParams', {
        ..._orderParams,
        ...router.query,
      });
    }
  }, [router.query, router.asPath]);
};

export default useSaveOrderParams;
